import { Injectable } from '@angular/core';

import { LocalStorageKeyBuilder } from '@recruitee/common';

@Injectable({ providedIn: 'root' })
export class LocalStorageKeyBuilderService extends LocalStorageKeyBuilder {
  public buildScopedKey(key: string): string {
    return key;
  }
}
